import classNames from "classnames";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import ProductPricedOrderFieldFormSection from "lib/components/FormSection/ProductPricedOrderFieldFormSection";
import { st, Form, FormMessage, Accordion, Button, HintView, FormControl } from "lib/index";
import { ProductOrderFieldDecorator } from "lib/decorators/index";
import Hint from "./StepPricedFieldsHint";
import { stateSelector, updateProduct, validate, save } from "../index";

@connect(
  (state) => ({
    product: stateSelector(state).product,
    submitLoading: stateSelector(state).submitLoading,
    valid: stateSelector(state).valid,
    errors: stateSelector(state).errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateProduct,
        validate,
        save,
      },
      dispatch
    )
)
export default class StepPricedFieldsForm extends React.PureComponent {
  state = {
    newField: null,
    activeFieldUuid: null,
  };

  componentDidMount() {
    this._createNewField();
  }

  _createNewField() {
    const { product } = this.props;
    const newField = ProductOrderFieldDecorator.build({
      _new: true,
      _focus: true,
      assignation_type: "assignation_per_order",
      price_type: "price_per_order",
      price: {
        value: 0,
        currency: product.price_currency,
      },
      price_included_in_order_base_amount: false,
      multiply_price_by_nights_count: false,
      position: Math.max(0, ...product.product_order_fields.map((field) => field.position)) + 1,
    });
    this.setState({ newField });
  }

  handleSubmit(event) {
    const { save } = this.props;
    event.preventDefault();
    save();
  }

  handleAddProductOrderField(nextField) {
    const { product, updateProduct } = this.props;
    const product_order_fields = product.product_order_fields.concat([nextField]);
    updateProduct({
      ...product,
      product_order_fields,
    });
  }

  handleUpdateProductOrderField(nextField) {
    const { product, updateProduct } = this.props;
    if (nextField._new) {
      this._createNewField();
      return this.handleAddProductOrderField(
        new ProductOrderFieldDecorator({ ...nextField, _new: undefined, _focus: undefined })
      );
    }
    const product_order_fields = product.product_order_fields.map((f) => (f.uuid === nextField.uuid ? nextField : f));
    updateProduct({
      ...product,
      product_order_fields,
    });
  }

  handleRemoveProductOrderField(field) {
    const { product, updateProduct, validate } = this.props;
    const product_order_fields = product.product_order_fields.filter((f) => f.uuid !== field.uuid);
    updateProduct({
      ...product,
      product_order_fields,
    });
    validate();
  }

  handleAccordionTitleClick(field) {
    const nextActiveFieldUuid = this.state.activeFieldUuid === field.uuid ? null : field.uuid;
    this.setState({ activeFieldUuid: nextActiveFieldUuid });
  }

  render() {
    const { updateProduct, readOnlyAccess, product, editedLocale, submitLoading, valid, errors, validate } = this.props;
    const { newField } = this.state;
    return (
      <HintView.Container>
        <HintView.Content>
          <Form className="text" onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
            <h2>{I18n.t("papp.products.EditProductView.StepPricedFields.form_title")}</h2>

            {!!errors.base && <FormMessage error={errors.base} />}

            <Accordion styled fluid>
              {product.priced_fields.concat(newField && !readOnlyAccess ? [newField] : []).map((field) => [
                <Accordion.Title
                  key={`title-${field.uuid}`}
                  active={this.state.activeFieldUuid === field.uuid}
                  className={classNames({
                    "title--error": !errors.hasValidProp(`product.product_order_fields[${field.uuid}]`),
                    new: field._new,
                  })}
                  onClick={this.handleAccordionTitleClick.bind(this, field)}
                >
                  {field._new
                    ? I18n.t("papp.products.EditProductView.StepPricedFields.add_new_field")
                    : field.name || I18n.t("papp.common.no_name")}
                  <i className="icon dropdown"></i>
                </Accordion.Title>,
                <Accordion.Content
                  key={`content-${field.uuid}`}
                  active={this.state.activeFieldUuid === field.uuid}
                  className={classNames({
                    new: field._new,
                  })}
                >
                  {this.state.activeFieldUuid === field.uuid && (
                    <ProductPricedOrderFieldFormSection
                      readOnlyAccess={readOnlyAccess}
                      name={`product.product_order_fields[${field.uuid}]`}
                      errors={errors}
                      product={product}
                      product_order_field={field}
                      editedLocale={editedLocale}
                      onBlur={validate}
                      onChange={this.handleUpdateProductOrderField.bind(this)}
                      onRemove={this.handleRemoveProductOrderField.bind(this, field)}
                      onClose={() => this.setState({ activeFieldUuid: null })}
                      externalSetState={this.setState.bind(this)}
                      updateProduct={updateProduct}
                    />
                  )}
                </Accordion.Content>,
              ])}
            </Accordion>

            <button type="submit" disabled={submitLoading} hidden />
          </Form>
        </HintView.Content>
        <HintView.Sidebar>
          <Hint />
        </HintView.Sidebar>
      </HintView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepPricedFields/StepPricedFieldsForm.jsx